import { PASSPORT_PATH_LIST } from '../config/routes/paths';
import { useRouteMatch } from 'react-router-dom';
import { normalizeRoutePath } from '../lib/helpers/urlHelper';

export default function useCurrentRoutePath(pathPrefix = ''): string | void {
  return PASSPORT_PATH_LIST
    .map(path => normalizeRoutePath(path, pathPrefix))
    .find(useRouteMatch);
}
